/* eslint-disable max-len */
import { Grid } from './Grid';

Grid.defaultProps = {
    flexWrap: 'wrap',
    display: 'flex',
    width: 1
};

export { Grid };
